import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../../common/withRouter';
import {
  SimpleDataTable as DataTable,
  Loader
} from '../../../web.common';
import { LayoutContext } from '../../layout/siteLayout';
import withApi from '../../higherOrderComponents/withApi';
import {
  DisplayDate,
  DisplayGuid,
  DisplayStatus
} from '../../items';
import { crawlingStatus } from '../../../enums/crawlingStatus';

class CrawlingResultInternal extends React.Component {
  constructor(props) {
    super(props);
    const { data } = this.props;
    this.state = {
      crawlings: data
    };
  }

  componentDidMount() {
  }

  render() {
    const { crawlings } = this.state;
    const { history } = this.props;

    console.log(crawlings);

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            <DataTable
              style={{ marginTop: '100px' }}
              loadingContent={(<Loader hasLoaded={false} />)}
              tableConfig={{
                tableName: 'crawlings-add',
                rowClasses: 'hover-listview',
                rowClick: ({ Id }) => {
                  history.push(`/crawling/${Id}`);
                },
                columns: [
                  {
                    property: 'Id',
                    label: 'Id',
                    render: ({ Id }) => <DisplayGuid>{Id}</DisplayGuid>
                  }, {
                    property: 'ProductId',
                    label: 'ProductId',
                    render: ({ ProductId }) => <DisplayGuid>{ProductId}</DisplayGuid>
                  }, {
                    property: 'Status',
                    label: 'Status',
                    render: ({ Status }) => <DisplayStatus mapping={crawlingStatus}>{Status}</DisplayStatus>
                  }, {
                    property: 'Executed At',
                    label: 'Executed At',
                    render: ({ ExecutedAt }) => <DisplayDate>{ExecutedAt}</DisplayDate>
                  }
                ]
              }}
              getData={() => crawlings}
              paginationData={{
                renderLocation: 'none'
              }}
              skipTableNoResults
              cellVerticalAlign='top'
              hideTableHead={false}
              languageCode='en'
              labels={{
                tableBody: {
                  noResult: <div style={{ display: 'block', textAlign: 'center' }}>No Results</div>
                }
              }}
              cellContent='cellContent'
            />
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const CrawlingResult = withRouter(withApi(
  connect(({ user }) => ({ isLoggedIn: !!user }), {})(CrawlingResultInternal)
));

CrawlingResult.requiresLogin = true;
CrawlingResult.propTypes = { isLoggedIn: PropTypes.bool };

export default CrawlingResult;